// utils/firstEl.js

/* Get the first element in an array of refs that exists */
/**
 * Utility function to get the first element out of an array of refs that exist
 */
export function firstEl(refs) {
  for (const r of refs || []) {
    if (r && r.current) return r.current;
  }
  return null;
}
